
export default {
   blankText: 'No Projects',
   createProject: '+ CREATE NEW PROJECT',
   upgrade: 'Upgrade',
   alertTitle: 'Upgrade Plan',

  mobileAlertTitle: 'Account Issue',
  mobileUpgradeButton: 'Manage on the web',
};



// WEBPACK FOOTER //
// ./src/views/user/components/modals/subscribe-modal/SubscribeModal.messages.js